import React, { useEffect, useState } from 'react';

interface LogoProps {
  size?: number;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ size = 40, className = '' }) => {
  const [primaryColor, setPrimaryColor] = useState('#0284c7');
  const [secondaryColor, setSecondaryColor] = useState('#7c3aed');

  useEffect(() => {
    // Get CSS variables from computed styles
    const updateColors = () => {
      const root = document.documentElement;
      const primary = getComputedStyle(root).getPropertyValue('--primary').trim() || '#0284c7';
      const secondary = getComputedStyle(root).getPropertyValue('--secondary').trim() || '#7c3aed';
      setPrimaryColor(primary || '#0284c7');
      setSecondaryColor(secondary || '#7c3aed');
    };

    // Update on mount
    updateColors();

    // Listen for theme changes
    const observer = new MutationObserver(updateColors);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['data-theme']
    });

    return () => observer.disconnect();
  }, []);

  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 64 64" 
      width={size} 
      height={size}
      className={className}
      style={{ display: 'block', flexShrink: 0 }}
    >
      <g>
        {/* O letter - circular, wraps around the entire XT */}
        <circle 
          cx="32" 
          cy="32" 
          r="30" 
          stroke={primaryColor} 
          strokeWidth="2" 
          fill="none"
        />
        {/* X letter - centered, endpoints touch inside of O */}
        <path 
          d="M 12 12 L 52 52 M 52 12 L 12 52" 
          stroke={primaryColor} 
          strokeWidth="2.5" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          fill="none"
        />
        {/* T letter - capital T, centered in the middle of X */}
        <path 
          d="M 12 12 L 52 12 M 32 12 L 32 60" 
          stroke={secondaryColor} 
          strokeWidth="2.5" 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          fill="none"
        />
      </g>
    </svg>
  );
};

export default Logo;

